import { bsModal } from "../plugins";
import { ajaxErrorAlert, ajaxPost, parceAjaxErrorResponse } from "../utils";
import { ErrorSwal, SuccessSwal, SwalPost } from "../../app";
import { Swal } from "../../vendor";

if ($("body").hasClass("logged-in")) {
  $(document).on("click", ".logoutBtn", (e) => {
    const button = $(e.currentTarget);
    Swal.fire({
      text: "Sistemdən çıxmağınıza əminsiniz?",
      // icon: 'question',
      // toast: true,
      showConfirmButton: true,
      confirmButtonText: "Sistemdən çıx",
      showDenyButton: true,
      denyButtonText: "İmtina",
      position: "center",
      allowOutsideClick: true,
      heightAuto: false,
    }).then((value) => {
      if (value.isConfirmed) {
        window.location.href = button.data("logout-url");
      }
    });
  });

  $(".userProfileModal").on("click", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);
    const userAccountModal = bsModal("small", {
      title: "Hesab",
      modalId: "userProfileModal",
      backdrop: "none",
    });
    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(userAccountModal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(userAccountModal).modal("hide");
        });
      });
  });

  $(document).on("click", ".userNotificationsModal", (e) => {
    e.preventDefault();
    const modal = bsModal("medium", {
      title: "Bildirişlər",
      modalId: "userNotificationsModal",
      backdrop: "none",
    });

    ajaxPost("/profile/notifications/", { action: "modal_content" })
      .then((response) => {
        $(modal).modal("content", response.html);
        // update notification count
        $(".userNotificationCount").text(
          String(response["unread_notification_count"]),
        );
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("click", ".twoFAModal", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);
    const modal = bsModal("small", {
      title: "2FA quraşdırılması",
      modalId: "user2FAModal",
      backdrop: "none",
    });

    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(modal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("submit", "#user2fAForm", (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "save_2fa_settings",
    });
    ajaxPost($(form).attr("action"), data, form)
      .then(() => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          $(".twoFAModal").trigger("click");
        });
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $(document).on("click", "#userProfileModal .changePasswordModal", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);

    const changePasswordModal = bsModal("small", {
      title: "Şifrənin dəyişdirilməsi",
      modalId: "changePasswordModal",
      backdrop: "none",
    });

    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(changePasswordModal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(changePasswordModal).modal("hide");
        });
      });
  });

  $(document).on("submit", "#changePasswordModal #changePasswordForm", (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "change_password",
    });
    ajaxPost($(form).attr("action"), data, form)
      .then((response) => {
        SuccessSwal.fire({}).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  $(document).on("click", "#userProfileModal .viewProfileModal", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);
    const modal = bsModal("small", {
      title: "Profil məlumatları",
      modalId: "profileViewModal",
      backdrop: "none",
    });

    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(modal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("click", "#userProfileModal .userEntryHistoryModal", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);

    const modal = bsModal("full", {
      title: "Sistemə giriş tarixçəsi",
      modalId: "userEntryHistoryModal",
      backdrop: "none",
    });

    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(modal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on("click", ".userSessionsModal", (e) => {
    e.preventDefault();
    const button = $(e.currentTarget);
    const changePasswordModal = bsModal("full", {
      title: "İstifadəçinin sessiyaları",
      modalId: "userSessionsModal",
      backdrop: "none",
    });

    ajaxPost(button.attr("href"), { action: "modal_content" })
      .then((response) => {
        $(changePasswordModal).modal("content", response.html);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors).join("<br>"),
        }).then(() => {
          $(changePasswordModal).modal("hide");
        });
      });
  });

  $(document).on("click", ".endMySession", (e) => {
    e.preventDefault();
    const url = $(e.currentTarget).attr("href");
    const sessionKey = $(e.currentTarget).data("session-key");
    SwalPost(
      url,
      { action: "end_session", session_key: sessionKey },
      {
        text: "Sessiyanı kəsmək istədiyinizdən əminsinizmi?",
        icon: "warning",
      },
    ).then((response) => {
      SuccessSwal.fire({ timer: 1000 }).then(() => {
        if (response["redirect_url"]) {
          window.location.href = String(response["redirect_url"]);
        } else {
          $(".userSessionsModal").trigger("click");
        }
      });
    });
  });

  $(document).on("click", ".endAllOtherUserSessions", (e) => {
    e.preventDefault();
    const url = $(e.currentTarget).attr("href");
    SwalPost(
      url,
      { action: "end_all_other_sessions" },
      {
        text: "Cari sessiyadan başqa bütün sessiyaları kəsmək istədiyinizdən əminsinizmi?",
        icon: "warning",
      },
    ).then(() => {
      SuccessSwal.fire({ timer: 1000 }).then(() => {
        $(".userSessionsModal").trigger("click");
      });
    });
  });

  $(document).on("click", ".deleteUserNotification", (e) => {
    const button = $(e.currentTarget);
    const id = button.data("id");
    const url = "/profile/notifications/" + id + "/delete/";

    button.attr("disabled", "disabled");
    ajaxPost(url, {}).then((response) => {
      button.closest(".card").fadeOut(200, () => {
        button.closest(".card").remove();
        if ($(".notificationList .card").length === 0) {
          $(".notificationListEmptyText").show();
        }
        $(".userNotificationCount").text(
          String(response["unread_notification_count"]),
        );
      });
    });
  });

  $(document).on("click", ".readUserNotification", (e) => {
    const button = $(e.currentTarget);
    const id = button.data("id");
    const url = "/profile/notifications/" + id + "/read/";

    button.attr("disabled", "disabled");
    ajaxPost(url, {}).then((response) => {
      button
        .closest(".card")
        .removeClass("border-primary")
        .removeClass("shadow-lg");
      button.remove();
      $(".userNotificationCount").text(
        String(response["unread_notification_count"]),
      );
    });
  });
}
